module.exports = __webpack_public_path__ + "static/img/text.daaaa81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/privacy/text.png
// module id = h+yB
// module chunks = 0